/**
 * Redux witness watchers for pages
 * @module services/pages/watchers
 */
import { SET_CONFIG_DATA } from '../config/redux/actions'
import { SET_AUTH_DATA } from '../auth/redux/actions'
import { setPageReady } from './redux/actions'

/**
 * Handle getting the config data
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness take after function
 */
export function appReadyHandler ({ after } = {}) {
  return after([SET_CONFIG_DATA, SET_AUTH_DATA], async ({ dispatch, state } = {}) => {
    // After all actions complete check the store to see if auth an config are ready
    const { auth, config, page } = state
    const configReady = !config.get('processing') && config.get('data')
    const authReady = !auth.get('processing') && auth.get('data')
    if (!page.get('ready') && authReady && configReady) {
      dispatch(setPageReady(true))
    }
  })
}
